import { Fragment, h } from "preact";

import Button from "./Button.jsx";
import i18n from "../i18n.js";
import { renderHtml } from "../helpers.js";

export default function WhitepaperPage() {
  return (
    <Fragment>
      <div class="center">
        <img src="/images/whitepaper_empty_state.svg" class="page-illu" />
      </div>

      <div class="row">
        <div class="col s12 l6 offset-l3 center">
          <h1 class="t-h6 t-h8--margin">
            {i18n.t("pages.whitepaper.errornous.title")}
          </h1>
          <p class="t-body3 mb-48">
            {renderHtml(i18n.t("pages.whitepaper.errornous.description"))}
          </p>

          <Button to="/tasks" secondary>
            {i18n.t("pages.whitepaper.errornous.action")}
          </Button>
        </div>
      </div>
    </Fragment>
  );
}
